/*
* Contains helper functions for dealing with VideoJsPlayer
*/

VideoJsPlayerHelper = new Class({
    Implements: Options,

    options: {
        playerId: null,
        url: null,
        type: "video/mp4",

        events: {
            onMetadata: null,
            onSeeked: null,
            onInit: null,
            onInitialPlay: null,
            onPause: null,
            onResume: null,
            onSeeking: null,
            onFinish: null
        },

        playerOptions: {
            controls: true,
            fluid: true,
            playbackRates: [0.5, 1, 1.25, 1.5, 2]
        }
    },

    VideoJsPlayerObj: null,

    videoTemplate: Handlebars.compile("\
        <video class='video-js vjs-big-play-centered' id='{{id}}_video' controls> \
            <source src='{{url}}' type='{{type}}'> \
        </video> \
    "),

    audioTemplate: Handlebars.compile("\
        <audio class='video-js vjs-big-play-centered' id='{{id}}_audio' controls> \
            <source src='{{url}}' type='{{type}}'> \
        </audio> \
    "),

    originalSize: null,

    //Events
    onPause: null,
    onResume: null,
    onBeforeSeek: null,
    onFinish: null,

    initialize: function(options) {
        this.setOptions(options);

        var isAudio = this.options.type.startsWith("audio");
        if (isAudio) {
            this.loadAudio(this.options);
        }
        else {
            this.loadVideo(this.options);
        }

        this.addEvents();

        return this;
    },

    loadAudio: function(options) {
        var playerId = options.playerId;
        this.mediaPlayerEl = this.createAudioElement(playerId, options.url, options.type);
        
        var audioId = playerId + "_audio";
        this.mediaPlayer = videojs(audioId, options.playerOptions);
    },

    loadVideo: function(options) {
        var playerId = options.playerId;
        this.mediaPlayerEl = this.createVideoElement(playerId, options.url, options.type);
        
        var videoId = playerId + "_video";
        this.mediaPlayer = videojs(videoId, options.playerOptions);
    },

    addEvents: function() {
        var self = this;
        // OnMetadata
        this.mediaPlayer.on("loadedmetadata", function (e, hash) {
            if (self.options.onMetaData) {
                self.options.onMetaData(self);
            }
        });

        // OnSeek
        this.mediaPlayer.on("seeked", function() {
            if (self.options.onSeek) {
                self.options.onSeek(self);
            }
        });

        // OnPause
        this.mediaPlayer.on("pause", function () {
            if (self.options.onPause) {
                self.options.onPause(self);
            }
        });

        // OnSeeking
        this.mediaPlayer.on("seeking", function () {
            if (self.options.onSeeking) {
                self.options.onSeeking(self);
            }
        });

        // OnSeeked
        this.mediaPlayer.on("seeked", function () {
            if (self.options.onSeeked) {
                self.options.onSeeked(self);
            }
        });

        // OnFinish
        this.mediaPlayer.on("ended", function () {
            if (self.options.onFinish) {
                self.options.onFinish(self);
            }

            self.hasPlayed = false;
        });

        // OnResume
        this.mediaPlayer.on("play", function () {
            if (self.options.onPlay) {
                self.options.onPlay(self);
            }
        });

        // OnInitialPlay
        this.mediaPlayer.on("firstplay", function () {
            self.hasPlayed = true;

            if (self.options.onInitialPlay) {
                self.options.onInitialPlay(self);
            }
        });
        this.mediaPlayer.on("timeupdate", function () {
        if (self.options.onTimeUpdate) {
            self.options.onTimeUpdate(self.mediaPlayer.currentTime(), self.mediaPlayer.duration());
        }
    });

    },

    createVideoElement: function(playerId, url, type) {
        var videoHtml = this.videoTemplate({
            id: playerId,
            url: url,
            type: type
        });

        var playerEl = $(playerId);
        playerEl.set("html", videoHtml);

        return playerEl;
    },

    createAudioElement: function(playerId, url, type) {
        var audioHtml = this.audioTemplate({
            id: playerId,
            url: url,
            type: type
        });

        var playerEl = $(playerId);
        playerEl.set("html", audioHtml);

        return playerEl;
    },

    seek: function(startTime) {
        this.mediaPlayer.play();
        this.mediaPlayer.currentTime(startTime);
    },

    unload: function() {
        this.mediaPlayer.dispose();
    },

    getDuration: function() {
        return this.mediaPlayer.duration();
    },

    getTime: function() {
        return this.mediaPlayer.currentTime();
    },

    isPlaying: function() {
        return !this.mediaPlayer.paused();
    },
    
    isPaused: function() {
        return this.mediaPlayer.paused();
    },

    isSeeking: function() {
    }
});
